/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Training_TabInputs */

const en_training_tab = /** @type {(inputs: Training_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training`)
};

const nl_training_tab = /** @type {(inputs: Training_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training`)
};

/**
* | output |
* | --- |
* | "Training" |
*
* @param {Training_TabInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const training_tab = /** @type {((inputs?: Training_TabInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Training_TabInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_training_tab(inputs)
	return en_training_tab(inputs)
});